import { registerDecorators as _registerDecorators, LightningElement, registerComponent as _registerComponent } from "lwc";
import _tmpl from "./productIcons.html";
import { throwDevelopmentOrLog } from '~/modules/utilities/errorUtilities';
import apiPackageTemplate from './apiPackageIcon.html';
import astroAgentTemplate from './astroAgentIcon.html';
import commerceTemplate from './commerceIcon.html';
import consultantTemplate from './consultantIcon.html';
import datoramaTemplate from './datoramaIcon.html';
import herokuTemplate from './herokuIcon.html';
import marketingTemplate from './marketingIcon.html';
import mulesoftTemplate from './mulesoftIcon.html';
import sfdcTemplate from './productIcons.html';
import quipTemplate from './quipIcon.html';
import slackTemplate from './slackIcon.html';
import tableauTemplate from './tableauIcon.html';
const ICON_TEMPLATES = {
  slack: slackTemplate,
  sfdc: sfdcTemplate,
  force: sfdcTemplate,
  apiPackage: apiPackageTemplate,
  quip: quipTemplate,
  b2c: commerceTemplate,
  commerce: commerceTemplate,
  datorama: datoramaTemplate,
  heroku: herokuTemplate,
  mulesoft: mulesoftTemplate,
  marketing: marketingTemplate,
  tableau: tableauTemplate,
  consultant: consultantTemplate,
  astro_agent: astroAgentTemplate
};
class ProductIcons extends LightningElement {
  constructor(...args) {
    super(...args);
    this.type = void 0;
    this.alternativeText = '';
    this.width = '62px';
    this.height = '62px';
  }
  render() {
    const template = ICON_TEMPLATES[this.type];
    if (!template) {
      throwDevelopmentOrLog(new Error(`Failed to find product icon of type: ${this.type}`));
    }
    return template || sfdcTemplate;
  }
  /*LWC compiler v7.1.3*/
}
ProductIcons.delegatesFocus = true;
_registerDecorators(ProductIcons, {
  publicProps: {
    type: {
      config: 0
    },
    alternativeText: {
      config: 0
    },
    width: {
      config: 0
    },
    height: {
      config: 0
    }
  }
});
const __lwc_component_class_internal = _registerComponent(ProductIcons, {
  tmpl: _tmpl,
  sel: "appx-product-icons",
  apiVersion: 62
});
export default __lwc_component_class_internal;